var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{staticClass:"bg-white mb-0",attrs:{"id":"studentsTable","items":_vm.table,"fields":_vm.fields,"empty-text":"Não encontramos nenhum resultado na busca :(","stacked":"md","sticky-header":true,"show-empty":"","bordered":"","hover":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }